import * as angular from 'angular';
import { ITimeFormatSettings } from '../models/ITimeFormatSettings';

export class TimeFormatService {
    private defaultTimeFormat = 'en';

    private timeFormatSettings = {
        en: {
            shortDateOnly: 'dd MMM',
            shortDateOnlyFullMonth: 'dd MMMM',
            longDateOnly: 'd MMMM yyyy',
            shortTimeOnly: 'hh:mm a',
            longTimeOnly: 'hh:mm:ss a',
            exactTime: 'dd MMM \'at\' hh:mm:ss a',
            weekDayOnly: 'EEEE',
            is24HourFormat: false
        } as ITimeFormatSettings,
        no: {
            shortDateOnly: 'dd MMM',
            shortDateOnlyFullMonth: 'dd MMMM',
            longDateOnly: 'd MMMM yyyy',
            shortTimeOnly: 'HH:mm',
            longTimeOnly: 'HH:mm:ss',
            exactTime: 'dd MMM \'at\' HH:mm:ss',
            weekDayOnly: 'EEEE',
            is24HourFormat: true
        }
    };

    public getTimeFormatSettings(lang: string): ITimeFormatSettings {

        if (this.timeFormatSettings[lang]) {
            return this.timeFormatSettings[lang];
        }

        return this.timeFormatSettings[this.defaultTimeFormat];
    }
}

angular.module('app.common').service('timeFormatService', TimeFormatService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/time-format.service.ts